/* global marketsCords locationsCords locationsCanvas */
class CalculateNearestPlacesService {
  nearest = {
    locations: [],
    markets: [],
    canvas: [],
    region: "",
  };

  constructor(geoData) {
    this.geoData = geoData;
  }

  calculateNearest = () => {
    const locationsCanvasCords =
      typeof locationsCanvas === "object" ? locationsCanvas : null;

    this.nearest = {
      markets: this.nearDistances(
        marketsCords,
        this.geoData.lat,
        this.geoData.lon
      ),
      locations: this.nearDistances(
        locationsCords,
        this.geoData.lat,
        this.geoData.lon
      ),
      locations_without_custom: this.nearDistancesNoCustom(
        locationsCords,
        this.geoData.lat,
        this.geoData.lon
      ),
      locations_checkout: this.nearDistancesOnlyAccess(
        locationsCords,
        this.geoData.lat,
        this.geoData.lon
      ),
      canvas: this.nearDistances(
        locationsCanvasCords,
        this.geoData.lat,
        this.geoData.lon
      ),
      region: this.geoData.regionName,
    };
  };

  calculateDistance = (lat1, lon1, lat2, lon2) => {
    if (lat1 === "" || lon1 === "" || lat2 === "" || lon2 === "") {
      return 999999999999;
    }

    var p = 0.017453292519943295;
    var c = Math.cos;
    var a =
      0.5 -
      c((lat2 - lat1) * p) / 2 +
      (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;

    return 12742 * Math.asin(Math.sqrt(a));
  };

  nearDistances = (locCords, lat, lon) => {
    if (typeof locCords === "object" && locCords) {
      let distances = [];
      locCords.forEach((location, i) => {
        distances[i] = {
          distance: this.calculateDistance(
            lat,
            lon,
            location.lat,
            location.lng
          ),
          city: location.title,
          id: location.id,
          parent_id: location.id,
          lat: location.lat,
          lng: location.lng,
        };
      });

      distances = distances.sort((prev, current) =>
        prev.distance > current.distance ? 1 : -1
      );
      //return only first 5 nearest
      return distances.slice(0, 5);
    } else {
      return [{ city: "New York" }];
    }
  };

  nearDistancesNoCustom = (locCords, lat, lon) => {
    if (typeof locCords === "object" && locCords) {
      let distances = [];
      locCords.forEach((location, i) => {
        if (!location.custom_location) {
          distances[i] = {
            distance: this.calculateDistance(
              lat,
              lon,
              location.lat,
              location.lng
            ),
            city: location.title,
            id: location.id,
            parent_id: location.id,
            lat: location.lat,
            lng: location.lng,
          };
        }
      });

      distances = distances.sort((prev, current) =>
        prev.distance > current.distance ? 1 : -1
      );
      //return only first 5 nearest
      return distances.slice(0, 5);
    } else {
      return [{ city: "New York" }];
    }
  };

  nearDistancesOnlyAccess = (locCords, lat, lon) => {
    if (typeof locCords === "object" && locCords) {
      let distances = [];
      locCords.forEach((location, i) => {
        if (
          !location.custom_location &&
          location.status === "open" &&
          location.products &&
          location?.products.indexOf(30107) > -1
        ) {
          distances[i] = {
            distance: this.calculateDistance(
              lat,
              lon,
              location.lat,
              location.lng
            ),
            city: location.title,
            id: location.id,
            parent_id: location.id,
            lat: location.lat,
            lng: location.lng,
            salesforce_id: location.salesforce_id,
          };
        }
      });

      distances = distances.sort((prev, current) =>
        prev.distance > current.distance ? 1 : -1
      );
      //return only first 5 nearest
      return distances.slice(0, 5);
    } else {
      return [{ city: "New York" }];
    }
  };
}

export default CalculateNearestPlacesService;
